import { render, staticRenderFns } from "./MagnetHandler.vue?vue&type=template&id=6bb70e3c&"
import script from "./MagnetHandler.vue?vue&type=script&lang=js&"
export * from "./MagnetHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports